import Link from 'molecules/Link';
import RichText from 'molecules/RichText';
import styles from 'molecules/TextCard/textcard.module.scss';

import type { TextCardProps } from 'molecules/TextCard/textcard.config';
import type { FC } from 'react';

const learningCenterDomain = process.env.NEXT_PUBLIC_LEARNING_CENTER_SITE_DOMAIN || '';

const TextCard: FC<TextCardProps & { className?: string; type?: 'capps' | 'cappsContained' }> = ({
  title,
  body,
  href,
  imageCard,
  image,
  type,
  className,
  headingTag,
}) => {
  const url = href === '/myMagMutual' ? learningCenterDomain : href;
  const HeadingTag = headingTag || 'h3';

  return (
    <div className={`${styles.container} ${!imageCard && url && styles.cover}`}>
      {imageCard ? (
        <div className={styles.image} style={{ backgroundImage: `url(${image?.url})` }} />
      ) : (
        <Link href={url || ''} className={styles.link} target="_self">
          <article className={`${styles.wrapper} ${className || ''}`}>
            {title &&
              (type === 'capps' ? (
                <HeadingTag className={styles.titleCap}>
                  <span className={styles.allCapsHeading}>{title}</span>
                </HeadingTag>
              ) : (
                <p className={styles.title}>{title}</p>
              ))}
            {body && (
              <div className={styles.margin_2}>
                <RichText className={styles.body} content={body} />
              </div>
            )}
          </article>
        </Link>
      )}
    </div>
  );
};

export default TextCard;
